import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ApiServerService } from '../services/api-server.service';

/** Sends API requests to the server selected in ApiServerService (production by default). */
export const apiServerInterceptor: HttpInterceptorFn = (req, next) => {
  const url = inject(ApiServerService).rewrite(req.url);
  return next(url === req.url ? req : req.clone({ url }));
};
